import request from '@shared/api/request';
import { API_TEST_CASE_PATH, API_TEST_PLAN_PATH } from '@shared/constants/pathsConstants';
import { INITIAL_TEST_PLAN_DATA } from '@shared/constants/initialDataConstants';
import { omit } from 'lodash';

export function getTestPlans(params) {
    return request.get(`/${API_TEST_PLAN_PATH}/`, { params });
}

export function getTestPlanById(id) {
    if (id === 'create')
        return new Promise((resolve) => {
            resolve({ data: INITIAL_TEST_PLAN_DATA });
        });
    return request.get(`/${API_TEST_PLAN_PATH}/${id}/`);
}

export function addTestPlan(props) {
    return request.post(`/${API_TEST_PLAN_PATH}/`, props);
}

export function editTestPlan(id, updatedFieldsInTestPlan) {
    return request.patch(`/${API_TEST_PLAN_PATH}/${id}/`, updatedFieldsInTestPlan);
}

export function deleteTestPlan(id) {
    return request.delete(`/${API_TEST_PLAN_PATH}/${id}/`);
}

export function addTestcasesToTestplan(params) {
    return request.post(
        `/${API_TEST_PLAN_PATH}/${params.testplanId}/${API_TEST_CASE_PATH}/`,
        omit(params, ['testplanId']),
    );
}

export function deleteTestcasesFromTestplan(params) {
    return request.delete(`/${API_TEST_PLAN_PATH}/${params.testplanId}/${API_TEST_CASE_PATH}/`, {
        data: { testcase_ids: params.testcase_ids },
    });
}

export function getTestplanType(params) {
    return request.get(`/${API_TEST_PLAN_PATH}/${params.testplanId}/type/`);
}
